import map from "lodash/map";
import DownloadLink from "PFApp/components/chat/download_link";
import { Stack } from "PFComponents/containers";
import { Divider } from "PFComponents/divider";
import { Typography } from "PFComponents/typography";
import { useAttachments } from "PFCore/hooks/queries/attachments/use_attachments";
import { Activity, GIdTargetType } from "PFTypes";
import { useTranslation } from "react-i18next";

import css from "./activity_details_common.module.scss";
import { ActivityDetailsMetadataProp } from "./activity_details_metadata_prop";
import { useMetadata } from "./use_metadata";

type ActivityDetailsMoreInfoProps = {
  activity?: Pick<Activity, "id" | "template_id" | "custom_fields" | "metadata">;
  metadataToOmit?: string[];
};

export const ActivityDetailsMoreInfo = ({ activity, metadataToOmit }: ActivityDetailsMoreInfoProps) => {
  const { t } = useTranslation("activities");
  const metadata = useMetadata({ activity, metadataToOmit });

  const { data: attachments } = useAttachments(
    {
      targetId: Number(activity?.id),
      targetType: GIdTargetType.Task
    },
    { enabled: !!activity }
  );

  // wrapping div is important here because we target last-child with css
  return (
    <Stack gap="spacingLg" data-qa-id="ActivityDetailsMoreInfo" className={css.infoMore}>
      {map(metadata, (prop) => prop.text && <ActivityDetailsMetadataProp key={prop.title} prop={prop} />)}

      {attachments?.entries && attachments?.entries.length > 0 && (
        <>
          <Divider />
          <Stack gap="spacingMd">
            <Typography variant="h6" clipOverflow>
              {t("show.details.attachments")}
            </Typography>
            <ul className={css.attachments}>
              {attachments?.entries.map((attachment) => (
                <li key={attachment.id}>
                  <DownloadLink attachment={attachment} useIcon={false} />
                </li>
              ))}
            </ul>
          </Stack>
        </>
      )}
    </Stack>
  );
};
